/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit SmileNoRetractors/view.blocks to change it.
import React from 'react'
import sourcePng from "./source.png"
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function SmileNoRetractors({
  children,
  viewPath = "/DesignSystem/Images/SmileNoRetractors",
  alignSelf = "auto",
  backgroundColor = "transparent",
  borderBottomLeftRadius = 0,
  borderBottomRightRadius = 0,
  borderTopLeftRadius = 0,
  borderTopRightRadius = 0,
  height = 800,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  marginTop = 0,
  source = sourcePng,
  width = 800
  
}) {
  return (<React.Fragment
>
<img
  data-testid="SmileNoRetractors.Image"
  data-view-path={viewPath}
 alt={""}
 src={source}
 style={{'--as-1-1VJ1cY': alignSelf,'--bc-2-1VJ1cY': backgroundColor,'--bblr-3-1VJ1cY': typeof borderBottomLeftRadius === 'number' ? `${borderBottomLeftRadius}px` : borderBottomLeftRadius,'--bbrr-4-1VJ1cY': typeof borderBottomRightRadius === 'number' ? `${borderBottomRightRadius}px` : borderBottomRightRadius,'--btlr-5-1VJ1cY': typeof borderTopLeftRadius === 'number' ? `${borderTopLeftRadius}px` : borderTopLeftRadius,'--btrr-6-1VJ1cY': typeof borderTopRightRadius === 'number' ? `${borderTopRightRadius}px` : borderTopRightRadius,'--h-7-1VJ1cY': typeof height === 'number' ? `${height}px` : height,'--mb-8-1VJ1cY': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-9-1VJ1cY': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-10-1VJ1cY': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--mt-11-1VJ1cY': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--w-12-1VJ1cY': typeof width === 'number' ? `${width}px` : width}}
 className={`views-block ${styles.Image}`}
/>
{children}
</React.Fragment>)
}